module.exports = __webpack_public_path__ + "static/media/CutStyleBeard.bc2fbb26.jpg";